export default __webpack_public_path__ + "beta-maps-guides-3d-terrain-960-b944b08215f3d2f712d6d156af31dea8.webp";